module.exports = __webpack_public_path__ + "img/P43-zh.18a6d230.png";